export default __webpack_public_path__ + "static/media/GreenDownArrow.efa371d0.svg";